import React, { useState } from 'react';
import { Section } from './ui/Section';
import { CTAButton } from './ui/CTAButton';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  q: '¿Es seguro pagar $6.30 por internet?',
  a: 'Sí, usamos plataformas de pago encriptadas que protegen tus datos.'
}, {
  q: '¿Tengo que saber mucho de tecnología?',
  a: 'No. Si sabes mandar un mensaje por WhatsApp, puedes aplicar este método.'
}, {
  q: '¿Qué pasa si tengo dudas?',
  a: 'El manual está escrito de forma tan sencilla que se explica solo, paso a paso.'
}, {
  q: '¿Me sirve si no hablo inglés perfecto?',
  a: 'Sí, el manual contempla estrategias para trabajar dentro de la comunidad latina y servicios donde el inglés no es la barrera principal.'
}];
export function FAQAndPricing() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section bg="bg-white" data-id="element-38">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 text-brand-brown" data-id="element-39">
        Preguntas Frecuentes
      </h2>

      <div className="max-w-2xl mx-auto space-y-4 mb-20" data-id="element-40">
        {faqs.map((faq, i) => <div key={i} className="border border-brand-sand rounded-xl overflow-hidden" data-id="element-41">
            <button className="w-full text-left p-5 bg-brand-cream hover:bg-brand-sand transition-colors flex justify-between items-center" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-42">
              <span className="font-bold text-lg text-brand-brown pr-4" data-id="element-43">
                {faq.q}
              </span>
              {openIndex === i ? <ChevronUp className="w-6 h-6 text-brand-brown-light flex-shrink-0" data-id="element-44" /> : <ChevronDown className="w-6 h-6 text-brand-brown-light flex-shrink-0" data-id="element-45" />}
            </button>
            {openIndex === i && <div className="p-5 bg-white text-lg text-brand-brown-light border-t border-brand-sand" data-id="element-46">
                {faq.a}
              </div>}
          </div>)}
      </div>

      <div id="pricing" className="bg-brand-cream p-8 md:p-12 rounded-3xl text-center max-w-2xl mx-auto border-2 border-brand-sand shadow-lg" data-id="element-47">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-brown mb-6" data-id="element-48">
          No queremos que el precio sea el obstáculo para que asegures tu
          futuro.
        </h2>
        <p className="text-lg md:text-xl text-brand-brown-light mb-8" data-id="element-49">
          No te cobraremos cientos de dólares. Queremos que cada latino en USA
          tenga este mapa de supervivencia.
        </p>

        <div className="mb-10" data-id="element-50">
          <p className="text-xl font-semibold text-brand-brown mb-2" data-id="element-51">
            Accede a todo el plan ahora por solo
          </p>
          <p className="text-6xl md:text-7xl font-extrabold text-brand-green" data-id="element-52">
            $6.30
          </p>
        </div>

        <CTAButton data-id="element-53" />

        <p className="mt-8 text-brand-brown-light text-sm md:text-base max-w-md mx-auto" data-id="element-54">
          Recibe tu guía inmediatamente después de la compra. Formato digital
          compatible con cualquier celular.
        </p>
      </div>
    </Section>;
}